<template>
  <div class="bg-login">
    <div
      class="d-flex justify-center align-center wrapper-content"
      fluid
      style="height: 100vh"
    >
      <v-container>
        <loader :loader="sending" />

        <v-row align="center" justify="center">
          <v-col cols="12" md="12" xl="10" sm="12">
            <v-row align="center" justify="center" class="mb-2">
              <v-col class="text-center" cols="12" md="6" lg="3" xl="3">
                <v-img src="@/assets/logo_suim.png" width="100%"></v-img>
                <br />
                <small class="white--text"
                  >Bienvenido, su descarga iniciará en un momento.</small
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script type="JS">
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { LoginRequest, DownloadZipRequest } from "@/core/request";

export default {
  components: {
    Loader,
    ValidationObserver,
    ValidationProvider
  },
  data: () => ({
    sending: false,
    model: { username: null, password: null },
    showPassword: false,
    textButtonSending: "",
    accessKey: null
  }),
  mounted() {
    this.accessKey = this.$route.params.idStudy;
    this.downloadStudy();
  },
  methods: {
    async downloadStudy() {

      if (!this.sending) {
        this.textButtonSending = "Descargando...";
        this.sending = true;
        DownloadZipRequest.downloadStudy(this.accessKey)
        .then((res) => {
          let { data } = res;
            let fileName = `ESTUDIO ${this.$utilFront.formatDateTime(new Date())}`;
            this.$utilFront.downloadZIP(data, fileName)
            this.sending = false;
        });
      //   .then((res) => {
      //       const url = URL.createObjectURL(
      //         new Blob([res.data], {
      //           type: "application/zip",
      //         })
      //       );
      //       let fileName = `ESTUDIO ${this.$utilFront.formatDateTime(new Date())}`;
      //       const link = document.createElement("a");
      //       link.href = url;
      //       link.setAttribute("download", fileName + ".zip");
      //       document.body.appendChild(link);
      //       link.click();

      //       document.body.removeChild(link);
      //     })
      //     .catch(this.catchError)
      //     .finally(() => {
      //       this.sending = false;
      //     });


       }

    }
  },
};
</script>

<style lang="scss" scoped>
.bg-login {
  background-image: url("../../../assets/suim_background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}

.loading-center {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
}

.form-head {
  text-align: center;
}

@media (min-width: 768px) {
  .img-fluid {
    width: 50%;
    height: 50%;
  }
}

@media (max-width: 768px) {
  .img-fluid {
    width: 70%;
    height: 100%;
  }
}

#sendLogin {
  margin-top: 20px;
}

/* Animacion de login  */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 2;
}

.button {
  text-transform: uppercase;
  font-weight: bold;
  height: 45px;
  letter-spacing: 2px;
}
</style>
